angular.module('scrf.notifications', [
    'sharecrf-auth',
    'sharecrf-sdk',
]);
